import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import logoImage from "@/assets/holionix-logo.jpeg";
import LanguageToggle from "./LanguageToggle";

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { name: "Solutions", path: "/solutions" },
    { name: "Platform", path: "/platform" },
    { name: "Industries", path: "/industries" },
    { name: "Products", path: "/products" },
    { name: "Compliance", path: "/compliance" },
    { name: "Resources", path: "/resources" },
  ];

  return (
    <nav className="fixed top-0 w-full glass-effect border-b border-border/50 z-50 shadow-lg">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3 group">
            <div className="relative">
              <img 
                src={logoImage} 
                alt="Holionix Logo" 
                className="h-12 w-12 rounded-lg transition-transform group-hover:scale-110" 
              />
              <div className="absolute inset-0 bg-gradient-to-r from-gradient-pink via-gradient-purple to-gradient-cyan rounded-lg opacity-0 group-hover:opacity-30 blur-xl transition-opacity"></div>
            </div>
            <span className="text-2xl font-bold gradient-brand-text">Holionix</span>
          </Link>

          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="text-foreground hover:text-accent transition-colors font-medium relative group"
              >
                {link.name}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 gradient-brand transition-all group-hover:w-full"></span>
              </Link>
            ))}
            <LanguageToggle />
            <Link to="/contact">
              <Button className="gradient-brand text-white hover:opacity-90 glow-effect">
                Book a Demo
              </Button>
            </Link>
          </div>

          <button
            className="lg:hidden text-foreground"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {isOpen && (
          <div className="lg:hidden pb-6 animate-fade-in">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-foreground hover:text-primary transition-colors font-medium py-2"
                  onClick={() => setIsOpen(false)}
                >
                  {link.name}
                </Link>
              ))}
              <Link to="/contact" onClick={() => setIsOpen(false)}>
                <Button className="w-full gradient-brand text-white hover:opacity-90">
                  Book a Demo
                </Button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
